/*!*
 * @author yueheqin
 * @date 2019/10/17
 * @project zujuanzaixian
 * @desc 试题篮中生成试卷
 */
import {mapActions, mapMutations, mapGetters} from 'vuex'
import {setLocalItem} from '../utils/storage'
import {getTmpPaperCallbackMixin} from '../mixins/zj-paper'

export const basketCreatePaperMixin = {
  mixins: [getTmpPaperCallbackMixin],
  computed: {
    ...mapGetters('common', ['currentSubject']),
    ...mapGetters('basket', ['quesBasket', 'paperCfg']),
    subjectID () {
      return this.currentSubject.id
    }
  },
  methods: {
    ...mapActions('basket', ['replaceBasketAction']),
    ...mapMutations('basket', ['addTypeCompose', 'clearTypeCompose']),
    ...mapActions('zujuan', ['getTmpPaper', 'saveTmpPaper']),
    bindCreatePaper () {
      let vm = this
      vm.getTmpPaperCallback({
        cancelButtonText: '生成新试卷',
        noTmp () {
          vm.createPaper()
        },
        cancel () {
          vm.createPaper()
        }})
    },
    createPaper () {
      let vm = this
      this.clearTypeCompose(vm.subjectID)
      let quesMap = vm.quesBasket[vm.subjectID]
      _.each(quesMap, item => {
        vm.addTypeCompose(item)
      })
      let arr = []
      _.each(quesMap, item => arr.push(item))
      let tempData = {
        paper: vm.paperCfg[vm.subjectID].defaultPaper,
        testList: arr
      }
      vm.replaceBasketAction(tempData)
      setLocalItem('paper_data', tempData)
      // 试题列表的生成试卷要关闭弹框
      console.log(vm.close)
      if (vm.close) vm.close()
      vm.$router.push({name: 'PaperView', query: {useLocal: '1'}})
    }
  }
}
